<template>    
    <div class="card-link">
        <a class="tool-item">
            <i v-bind:class="item.icon"></i>
        </a>
        <a v-on:click="recordLead" v-bind:href="item.href" target="_blank">{{item.label}}</a>
    </div>
</template>

<script>
import {LeadBus} from '../router/index';
export default
{
    props: {
        item: {}
    },

    methods: {
        recordLead() {
            LeadBus.$emit('recordLead', {type: 'presenter-profile-card', data: {label: this.item.label, link: this.item.href}});
        }
    }
};

</script>

<style lang="scss">
.icon {
    display: inline-block;
    max-width: 0.9em;
    max-height: 0.9em;
    border-style: none;
    box-sizing: inherit;
    padding-left: 2px;                      
}
</style>



// WEBPACK FOOTER //
// PresenterLink.vue?53f36119